import { useSearchParams } from 'react-router-dom';

import { useFeatureFlags } from 'ha/modules/FeatureFlags';

import { MUL_WHITELISTED_COUNTRIES, MUL_QUERY_KEY } from '../constants';

const useMulFeatureFlags = (country?: string) => {
  const [searchParams] = useSearchParams();
  const hasMulQuery = searchParams.get(MUL_QUERY_KEY) || undefined;

  const { tenantMULFlow, advertiserMulCRUD, advertiserAllowMulCreation } =
    useFeatureFlags();

  const enableExperiment = MUL_WHITELISTED_COUNTRIES.includes(country || '');
  const enableExperimentAdv = !!hasMulQuery;

  const isTenantMULFlowEnabled = tenantMULFlow === 'on' && enableExperiment;
  const isAdvertiserMulCRUDEnabled =
    advertiserMulCRUD === 'on' && (enableExperiment || enableExperimentAdv);
  const isAdvertiserAllowMulCreationEnabled =
    advertiserAllowMulCreation === 'on';

  return {
    isTenantMULFlowEnabled,
    isAdvertiserMulCRUDEnabled,
    isAdvertiserAllowMulCreationEnabled,
  };
};

export { useMulFeatureFlags };
